import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { ContributeLandingPageIcon } from './contribute-landing-page';
import { contributeRootRouteRef } from '../../routes';

export const contributeLandingPage = PageBlueprint.make({
  params: {
    title: 'Plugin or Template Decision Guide',
    path: '/contribute/decision-guide',
    icon: ContributeLandingPageIcon,
    routeRef: contributeRootRouteRef,
    loader: () =>
      import('./contribute-landing-page').then(m => (
        <m.ContributeLandingPage />
      )),
  },
});

export const contributeLandingPagePlugin = createFrontendPlugin({
  pluginId: 'contribute-landing-page',
  extensions: [contributeLandingPage],
  routes: { root: contributeRootRouteRef },
});
